import React from "react"
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'
import get from 'lodash/get'
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap"
import CustomModal from '../../components/modal'
import { SimpleModal } from '../../components/modal/simple-modal'
import { modalButtons } from '../../components/buttons/modal-button'
import Pass from '../../static/images/lock.svg'
import User from '../../static/images/man-user.svg'
import { ResetPassword } from '../../components/login/reset-password'
import { authSelector, modalSelector } from './../../selectors'
import { authAction, modalAction } from './../../actions/'

const logo = require(`../../static/images/kawari-logo-${process.env.REACT_APP_LOGO}.svg`)

class Login extends React.Component {
  static getDerivedStateFromProps(nextProps) {
    if (get(nextProps, 'authData.status') === 200) {
      localStorage.setItem('access_token', get(nextProps, 'authData.auth.access_token'))
      localStorage.setItem('is_pm_role', get(nextProps, 'authData.auth.is_pm_role'))
      localStorage.setItem('is_hr_admin_role', get(nextProps, 'authData.auth.is_hr_admin_role'))
      localStorage.setItem('is_hr_admin_confidential_role', get(nextProps, 'authData.auth.is_hr_admin_confidential_role'))
      localStorage.setItem('is_accountant_role', get(nextProps, 'authData.auth.is_accountant_role'))
      localStorage.setItem('is_init_user', get(nextProps, 'authData.auth.is_init_user'))
      localStorage.setItem('created', get(nextProps, 'authData.auth.created'))
      localStorage.setItem('hashed_password', get(nextProps, 'authData.auth.hashed_password'))
      localStorage.setItem('is_system_admin', get(nextProps, 'authData.auth.is_system_admin'))
      localStorage.setItem('last_name', get(nextProps, 'authData.auth.last_name'))
      localStorage.setItem('id_card', get(nextProps, 'authData.auth.id_card'))
      localStorage.setItem('salt', get(nextProps, 'authData.auth.salt'))
      localStorage.setItem('__v', get(nextProps, 'authData.auth.__v'))
      localStorage.setItem('first_name_th', get(nextProps, 'authData.auth.first_name_th'))
      localStorage.setItem('_id', get(nextProps, 'authData.auth._id'))
      localStorage.setItem('first_name', get(nextProps, 'authData.auth.first_name'))
      localStorage.setItem('updated', get(nextProps, 'authData.auth.updated'))
      localStorage.setItem('is_active', get(nextProps, 'authData.auth.is_active'))
      localStorage.setItem('email', get(nextProps, 'authData.auth.email'))
      localStorage.setItem('is_management_role', get(nextProps, 'authData.auth.is_management_role'))
      localStorage.setItem('access_token', get(nextProps, 'authData.auth.access_token'))
      localStorage.setItem('last_name_th', get(nextProps, 'authData.auth.last_name_th'))
      localStorage.setItem('image_url', get(nextProps, 'authData.auth.image_url'))
      localStorage.setItem('emp_code', get(nextProps, 'authData.auth.emp_code'))
      localStorage.setItem('lob_id', get(nextProps, 'authData.auth.lob_id'))
      localStorage.setItem('position_id', get(nextProps, 'authData.auth.position_id'))
      localStorage.setItem('hiring_date', get(nextProps, 'authData.auth.hiring_date'))
      nextProps.history.push('home')
    } else if (get(nextProps, 'authData.auth')) {
      nextProps.showModal('login', get(nextProps, 'authData.status'), get(nextProps, 'authData.message'))
      nextProps.resetAuth()
    }
    return null
  }

  constructor(props) {
    super(props)
    if (process.env.REACT_APP_DEBUG === 'true') {
      this.state = {
        Company_Email: 'system@iacadmin.test',
        Password: '12341234',
        image: logo,
        modal: false,
        email: '',
      }
    } else {
      this.state = {
        Company_Email: '',
        Password: '',
        image: logo,
        modal: false,
        email: '',
      }
    }
  }

  componentDidMount() {
    const maintenanceMsg = process.env.REACT_APP_MAINTENANCE_MESSAGE
    if (maintenanceMsg && maintenanceMsg !== '') this.props.showModal('alert', '', maintenanceMsg)
  }

  toggle = () => {
    this.props.hideModal()
  }

  handleForget = () => {
    this.props.showModal('forgetPassword', 200)
  }

  handleEmail = (e) => {
    if (e.target.value !== '') this.setState({ [e.target.name]: e.target.value })
    else this.setState({ [e.target.name]: '' })
  }

  handlePassword = (e) => {
    if (e.target.value !== '') this.setState({ Password: e.target.value })
    else this.setState({ Password: '' })
  }

  enterPressed = (event) => {
    const code = event.keyCode || event.which
    if (code === 13) {
      this.props.auth({ email: this.state.Company_Email.trim(), password: this.state.Password })
    }
  }

  checkLogin = () => {
    this.setState({ modal: false })
    this.props.auth({ email: this.state.Company_Email.trim(), password: this.state.Password })
  }

  forgetPassword = async () => {
    const res = await this.props.resetPassword({ email: this.state.email.trim() })
    const resp = res.payload
    this.props.openResponseModal({
      responseModal: {
        isOpen: true,
        res: {
          type: resp.ok ? 'success' : 'error',
          title: resp.ok ? 'Successful' : 'Error',
          description: resp.ok ? 'Please check your email to reset the password.'
            : (resp.response ? resp.response.message : resp.message),
          actions: modalButtons(resp.ok ? 'success' : 'error', { close: this.closeResponseModal }),
        },
      },
    })
    this.props.hideModal('forgetPassword')
  }

  closeResponseModal = () => {
    this.props.openResponseModal({ responseModal: { isOpen: false, res: {} } })
  }

  render() {
    if (localStorage.getItem('bad_token') === 'true') {
      this.props.showModal('login', 'Error',
        `Your account session has been expired or has been logged in from another device. Please login again.`)
      localStorage.removeItem('bad_token')
    }
    if (get(this.props, 'authData.isAuthenticated')) {
      if (get(this.props, 'history.pathname')) {
        return <Redirect to={ this.props.history.pathname } />
      }
      return (<Redirect to={ {
        pathname: `/home`,
        state: { header: 'My Dashboard' },
      } }
      />)
    }
    const modalType = get(this.props, 'modalType')
    const modalStatus = get(this.props, 'modalStatus')
    const modalMessage = get(this.props, 'modalMessage')
    const authData = get(this.props, 'authData')
    const responseModal = authData.responseModal

    return (
      <ContainerLogin>
        <RowLogin className="justify-content-center">
          <ColLogin>
            <CustomModal
              hide={ this.props.hideModal }
              show={
                modalType === 'login'
                || modalType === 'alert'
              }
              type={ modalStatus }
              message={ modalMessage }
              fontColor={ modalType === 'alert' ? 'black' : '' }
            />
            <CardGroup className="mb-0">
              <CardLogin>
                <CardBody className="card-body">
                  <LogoImg id="target" src={ this.state.image } alt={ "Avatar" } />
                  <LabelWelcome>Welcome</LabelWelcome>
                  <br />
                  <InputSection className="mb-3">
                    <InputGroupAddon addonType='append'>
                      <i className="icon-user" />
                    </InputGroupAddon>
                    <Icon src={ User } />
                    <InputSt
                      name="Company_Email"
                      placeholder="username"
                      type="text"
                      value={ this.state.Company_Email }
                      onChange={ this.handleEmail }
                      onKeyPress={ this.enterPressed }
                    />
                  </InputSection>
                  <PasswordSection className="mb-4">
                    <InputGroupAddon addonType='append'>
                      <i className="icon-lock" />
                    </InputGroupAddon>
                    <Icon src={ Pass } />
                    <InputSt
                      name="Password"
                      type="password"
                      placeholder="password"
                      value={ this.state.Password }
                      onChange={ this.handlePassword }
                      onKeyPress={ this.enterPressed }
                    />
                  </PasswordSection >
                  <Row>
                    <Col xs="12" className="text-center">
                      <LoginButton onClick={ this.checkLogin } >
                        LOGIN
                      </LoginButton>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" className="text-center">
                      <ForgotButton onClick={ this.handleForget } className="px-0">
                        Forgot your password?
                      </ForgotButton>
                    </Col>
                  </Row>
                </CardBody>
              </CardLogin >
            </CardGroup>
          </ColLogin>
        </RowLogin>
        <SimpleModal
          isOpen={ responseModal.isOpen }
          toggle={ this.closeResponseModal }
          { ...responseModal.res }
        />
        <ResetPassword
          open={ modalType === 'forgetPassword' }
          toggle={ this.toggle }
          handleEmail={ this.handleEmail }
          forgetPassword={ this.forgetPassword }
        />
      </ContainerLogin>
    )
  }
}

Login.propTypes = {
  auth: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    authState: authSelector.getAuth,
    authData: authSelector.getUserData,
    modalStatus: modalSelector.modalStatus,
    modalType: modalSelector.modalType,
    modalMessage: modalSelector.modalMessage,
  })(state, props)
}
const mapDispatchToProps = dispatch => bindActionCreators({
  auth: authAction.authenticate,
  resetAuth: authAction.resetAuth,
  resetPassword: authAction.resetPassword,
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  openResponseModal: authAction.openResponseModal,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Login)

const ContainerLogin = styled(Container)`
  @media (max-width: 1199.98px) {
    width: 40%;
  }
  @media (max-width: 991.98px) {
    width: 40%;
  }
  @media (max-width: 767.98px){
    width: 100%;
  }
  @media (max-width: 575.98px) {
    width: 100%;
  }
  height : 100%;
  width: 30%;
  align-content: center;
  margin-top: 10%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
`
const CardLogin = styled(Card)`
  background-color: #1A1A17;
`
const InputSt = styled(Input)`
  height : 30px;
  border: none ;
  margin-right: 5%;
  border-radius: 0% ;
`
const ColLogin = styled(Col)`
  height: 100%;
  width: 30%;
`
const RowLogin = styled(Row)`
  @media (max-width: 767.98px){
    margin-left: 0px;
    margin-right: 0px;
  }
  @media (max-width: 575.98px) {
    margin-left: 0px;
    margin-right: 0px;
  }
  height : 150% ;
  width: 100% ;
`
const Icon = styled.img`
  margin-left: 5%;
  padding: 8px ;
  height : 30px;
  width: 30px;
  border: none;
  text-align: center;
  background-color: #FFFFFF;
`
const InputSection = styled(InputGroup)`
  margin-top: 10%;
`
const PasswordSection = styled(InputGroup)`
  margin-top: 5%;
`
const LabelWelcome = styled.p`
  font-family: 'Gotham' !important;
  margin-top: 10px;
  font-weight: Bolder;
  font-size: 14px ;
  color: #FFFFFF;
  text-align: center;
`
const LogoImg = styled.img`
  width: 60%;
  display: block;
  margin-left: auto;
  margin-right: auto;
`
const LoginButton = styled.button`
  height : 50% ;
  width: 90%;
  margin-top: 35px;
  margin-bottom: 25px;
  background-color: #AE2527;
  margin-right: 5%;
  margin-left: 5%;
  border: none ;
  color: #FFFFFF ;
  font-size: 10px ;
  outline: 0;
  font-family: 'Gotham-Bold';
  &:focus {
    outline: 0;
    background-color: #5C1415;
  }
  &:hover {
    outline: 0;
    background-color: #8A1D1F;
  }
`
const ForgotButton = styled.button`
  margin-top: 10px;
  margin-bottom: 30px;
  background-color: transparent;
  margin-right: 5%;
  margin-left: 5%;
  border: none;
  color: #FFFFFF;
  font-size: 10px;
  font-family: 'Gotham';
`




// WEBPACK FOOTER //
// ./src/pages/login/index.js